import { MatMenu } from '@angular/material/menu';

export abstract class MatMenuCustomComponent<T> {
  abstract items: (T)[];
  abstract childMenu: MatMenu;
}
